import { createStore } from 'vuex'
import auth from './modules/auth.js'
import userInfo from './modules/userInfo.js'
import userPreferences from './modules/userPreferences.js'
import project from './modules/project.js'
import users from './modules/users.js'
import ui from './modules/ui.js'
import overlaySigners from './modules/overlaySigners.js'

export default createStore({
    modules: {
      auth,
      userInfo,
      userPreferences,
      project,
      users,
      ui,
      overlaySigners
    },

    state:{

    },

    getters: {

    },

    mutations: {

    },

    actions: {

    },
})
